import type {
  CallPolicyContext,
  CanContext,
  LessonPolicyContext,
  NavigationPolicyContext,
  StudentPolicyContext,
} from '~/shared/permissions/types';
import type { ShortUserType } from '~/types';

import { canCall } from './policies/call.policy';
import { canLesson } from './policies/lesson.policy';
import { canNavigation } from './policies/navigation.policy';
import { canStudent } from './policies/student.policy';

export function can(user: ShortUserType | null, permission: string, ctx: CanContext = {}): boolean {
  if (!user?.role) {
    return false;
  }

  if (permission.startsWith('lesson.')) {
    return canLesson(user, permission, ctx as LessonPolicyContext);
  }

  if (permission.startsWith('call.')) {
    return canCall(user, permission, ctx as CallPolicyContext);
  }

  if (permission.startsWith('student.')) {
    return canStudent(user, permission, ctx as StudentPolicyContext);
  }

  if (permission.startsWith('web.') || permission.startsWith('platform.') || permission.startsWith('admin.')) {
    return canNavigation(user, permission, ctx as NavigationPolicyContext);
  }

  return false;
}
